import urlEncodeManager from '@/services/general/urlEncodeManager';
import {
  PANNEAUX_FROM_VENTES_LC,
  PANNEAUX_FROM_VENTES_NUMERIQUES,
  FACES_FROM_VENTES_RESEAUX,
} from '@/configuration/carteConf';

export function panneauxLcUrlPhotoManager(item, decode) {
  item.urlPhoto = urlEncodeManager(item.urlPhoto, decode);
  if (item.extensionOpportunite) {
    item.extensionOpportunite.urlPhoto = urlEncodeManager(
      item.extensionOpportunite.urlPhoto, decode);
    if (item.extensionOpportunite.faceSelectionne) {
      item.extensionOpportunite.faceSelectionne.urlPhoto = urlEncodeManager(
        item.extensionOpportunite.faceSelectionne.urlPhoto, decode);
    }
  }
}
export function panneauxNumeriqueUrlPhotoManager(item, decode) {
  item.urlPhoto = urlEncodeManager(item.urlPhoto, decode);
}
export function reseauxUrlPhotoManager(item, decode) {
  item.urlPhoto = urlEncodeManager(item.urlPhoto, decode);
  item.listeFaces.forEach(face => {
    face.urlPhoto = urlEncodeManager(face.urlPhoto, decode);
  });
}
export function reseauxPersonnaliseUrlPhotoManager(item, decode) {
  item.urlPhoto = urlEncodeManager(item.urlPhoto, decode);
  item.produitsWithAllData.forEach(face => {
    switch (face.typeProduit) {
      case PANNEAUX_FROM_VENTES_LC:
        panneauxLcUrlPhotoManager(face, decode);
        break;
      case PANNEAUX_FROM_VENTES_NUMERIQUES:
        panneauxNumeriqueUrlPhotoManager(face, decode);
        break;
      case FACES_FROM_VENTES_RESEAUX:
        face.urlPhoto = urlEncodeManager(face.urlPhoto, decode);
        break;
      default:
        break;
    }
  });
}



// WEBPACK FOOTER //
// ./src/services/opportunite/opportuniteUrlPhotoManager.js